export function ChatFill1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.986 10.013a6.5 6.5 0 10-.506 11.265h2.798v-2.89c.432-.87.722-1.85.722-2.888a6.495 6.495 0 00-3.014-5.487z"
      ></path>
      <path
        fill="currentColor"
        d="M18.468 7.532A8.5 8.5 0 002 10.5c0 1.295.338 2.503.833 3.562v4.105h3.993c.23.11.465.21.706.3A8.5 8.5 0 0118.467 7.532z"
      ></path>
    </svg>
  );
}
